
import routeNames from './route-names'
import BaseRouterView from '@/components/base/BaseRouterView'

const BundlesTabs = () => import(/* webpackChunkName: "bundlestabs" */'@/views/bundle/BundlesTabs')
const Bundles = () => import(/* webpackChunkName: "bundles" */'@/views/bundle/Bundles')

const BundleTabs = () => import(/* webpackChunkName: "bundletabs" */'@/views/bundle/bundle/BundleTabs')
const Overview = () => import(/* webpackChunkName: "overview" */'@/views/bundle/bundle/overview/Overview')
const UsageHistory = () => import(/* webpackChunkName: "usagehistory" */'@/views/bundle/bundle/usage-history/UsageHistory')
const UsageHistorySummary = () => import(/* webpackChunkName: "usagehistory-numbers" */'@/views/bundle/bundle/usage-history/summary/UsageHistorySummary')
const Charts = () => import(/* webpackChunkName: "charts" */'@/views/bundle/charts/Charts')


function props (route) {
    return {
        bundleId: parseInt(route.params.bundleId),
    }
}

export default {
    path: '/tools/bundles',
    alias: '/bundles',
    component: BaseRouterView,
    children: [
        {
            path: '/',
            meta: {title: 'Bundles'},
            component: BundlesTabs,
            children: [
                {
                    path: '/',
                    name: routeNames.BUNDLES,
                    meta: {title: 'Bundles'},
                    component: Bundles,
                }
            ]
        },
        {
            path: ':bundleId',
            component: BundleTabs,
            props,
            children: [
                {
                    path: '/',
                    name: routeNames.BUNDLE,
                    meta: {title: 'Bundle'},
                    component: Overview
                },
                {
                    path: 'usage-history',
                    name: routeNames.BUNDLE_USAGE_HISTORY,
                    props,
                    meta: {title: 'Usage History'},
                    component: UsageHistory,
                    children: [
                        {
                            path: 'summary',
                            name: routeNames.BUNDLE_USAGE_HISTORY_SUMMARY,
                            props,
                            meta: {title: 'Usage History Summary'},
                            component: UsageHistorySummary,
                        },
                    ]
                },
                {
                    path: 'charts',
                    name: routeNames.BUNDLE_CHARTS,
                    props,
                    meta: {title: 'Charts'},
                    component: Charts
                },
            ]
        }
    ]
}
